export default __webpack_public_path__ + "static/media/close-icon.c13fc3dd.svg";